import { Toasts } from '@fourthwall/components';
import { useDnsQuery } from '../../../../../../../hooks/useDnsQuery';
import { useCreateDomainMutation } from '../../../queries/useCreateDomainMutation';
import { useGetPaidDomainsQuery } from '../queries/useGetPaidDomainsQuery';
import { useRegisterPaidDomainMutation, } from '../queries/useRegisterPaidDomainMutation';
import { splitDomain } from '../utils/splitDomain';
export const usePaidDomain = () => {
    const { getPaidDomainsQuery, invalidateGetPaidDomainsQuery } = useGetPaidDomainsQuery();
    const { registerPaidDomainMutation } = useRegisterPaidDomainMutation();
    const { createDomainMutation } = useCreateDomainMutation();
    const { invalidateDnsQuery } = useDnsQuery([], {});
    const registerDomain = async (domain) => {
        const { mainDomain, tld } = splitDomain(domain);
        await registerPaidDomainMutation.mutateAsync([{ name: mainDomain, tld: tld }]);
        createDomainMutation.mutate({
            domain,
        }, {
            onSuccess: () => {
                Toasts.notify("We're pulling information about the domain. This can take up to 30 seconds.", {
                    type: 'info',
                    autoClose: false,
                });
            },
        });
        invalidateGetPaidDomainsQuery();
        invalidateDnsQuery();
    };
    return {
        currentDomain: getPaidDomainsQuery.data?.[0] || null,
        isLoading: getPaidDomainsQuery.isLoading,
        isRegistering: registerPaidDomainMutation.isLoading,
        registerDomain,
    };
};
